import React, {PureComponent} from "react";
import PropTypes from "prop-types";
import priceFormat from "../../../services/lib/price-format";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import NoSsr from "@material-ui/core/NoSsr";

export default class CheckboxTemplate extends PureComponent {
  static propTypes = {
    variant: PropTypes.string.isRequired,
    title: PropTypes.string,
    items: PropTypes.array.isRequired,
    changeVariant: PropTypes.func,
    currentValue: PropTypes.string,
    dict: PropTypes.object,
    customHandleClick: PropTypes.func,
    priceMap: PropTypes.number
  };
  render() {
    const {
      variant,
      items,
      changeVariant,
      customHandleClick,
      currentValue,
      priceMap,
      title
    } = this.props;
    return (
      <div className={`variant variant_${variant}`}>
        <div className="variant__content">
          <NoSsr>
            <FormControlLabel
              control={
                <Checkbox
                  checked={currentValue === items[1]}
                  onChange={(e) => {
                    const value = e.target.checked ? items[1] : items[0];
                    if (customHandleClick) {
                      customHandleClick(e, variant, value);
                    }
                    changeVariant(e, variant, value);
                  }}
                  color="primary"
                />
              }
              label={
                title
                  ? `${title} ${priceMap ? priceFormat(priceMap) : ``}`
                  : null
              }
            />
          </NoSsr>
        </div>
      </div>
    );
  }
}
